import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/loan/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/loan/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/loan/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/loan/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/loan/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/loan` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/loan?title=${title}` , { headers: authHeader() });
};

const getSummary = (params) => {
  return http.get(`/loan/analytics/summary`, { headers: authHeader(), params });
};

const LoanService = {
  getAll,
  get,
  getSummary,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default LoanService;
